import styled from 'styled-components';

export const DiagnosisEntryRow = styled.div.attrs<{ $disabled?: boolean }>({
  className: 'flex items-start gap-2 px-5 py-2 text-xs text-card-foreground',
})<{ $disabled?: boolean }>`
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;
